import { Package, Globe, AlertCircle, FileText, HelpCircle } from "lucide-react";
import { Link } from "react-router-dom";

const CustomsDuty = () => {
  return (
    <div className="pt-24 pb-16" data-testid="customs-duty-page">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="label-style mb-2">International Orders</p>
          <h1 
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{ fontFamily: 'Calibri, Carlito, "Segoe UI", sans-serif' }}
          >
            Customs / Duty Charges
          </h1>
          <p className="text-muted-foreground max-w-xl mx-auto">
            It is the purchaser's / importer's sole responsibility for import taxes.
          </p>
        </div>

        {/* Important Notice */}
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 mb-8">
          <div className="flex items-start gap-4">
            <AlertCircle className="h-6 w-6 text-amber-600 shrink-0 mt-0.5" />
            <div>
              <h2 
                className="font-bold text-lg mb-2 text-amber-800"
                style={{ fontFamily: 'Calibri, Carlito, "Segoe UI", sans-serif' }}
              >
                Important Notice
              </h2>
              <p className="text-amber-700">
                If your order is delivered outside the UK, it may be subject to import taxes, customs duties and charges in the destination country, payable by the customer. Mini Stripes UK has no responsibility for these charges.
              </p>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="space-y-8">
          {/* Customs and Duty for imports */}
          <div className="bg-white border border-border rounded-lg p-6 md:p-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center shrink-0">
                <Globe className="h-6 w-6 text-primary" />
              </div>
              <div>
                <h2 
                  className="font-bold text-xl mb-3"
                  style={{ fontFamily: 'Calibri, Carlito, "Segoe UI", sans-serif' }}
                >
                  Customs and Duty for imports
                </h2>
                <p className="text-muted-foreground mb-4">
                  Local duty or customs taxes may be levied by the purchaser's country if you are located in Switzerland, Norway, North America, South America, Africa, Asia or Oceania.
                </p>
                <p className="text-muted-foreground">
                  It is the purchaser's / importer's sole responsibility for import taxes. These will usually be levied by the shipping company.
                </p>
              </div>
            </div>
          </div>

          {/* Brexit Section */}
          <div className="bg-white border border-border rounded-lg p-6 md:p-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-secondary rounded-full flex items-center justify-center shrink-0">
                <FileText className="h-6 w-6 text-muted-foreground" />
              </div>
              <div>
                <h2 
                  className="font-bold text-xl mb-3"
                  style={{ fontFamily: 'Calibri, Carlito, "Segoe UI", sans-serif' }}
                >
                  Brexit
                </h2>
                <p className="text-muted-foreground mb-4">
                  Brexit took force on 1st 2021. From this date all sales to EU member nations may be subject to import fees. Here we have a simple guide for what to expect:
                </p>
                <ul className="list-disc list-inside text-muted-foreground space-y-3">
                  <li>If applicable to your order, these fees are automatically calculated by the shipping company.</li>
                  <li>There are no delays with delivery. Shipping companies pay upfront to customs in your country and then bill you later if any fees apply.</li>
                  <li>If you return your goods you can apply for a refund from the shipping company.</li>
                  <li>Please check your country's own VAT and customs import duty so you are aware if any fees will be payable.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="bg-white border border-border rounded-lg p-6 md:p-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center shrink-0">
                <HelpCircle className="h-6 w-6 text-primary" />
              </div>
              <div>
                <h2 
                  className="font-bold text-xl mb-3"
                  style={{ fontFamily: 'Calibri, Carlito, "Segoe UI", sans-serif' }}
                >
                  Need Help?
                </h2>
                <p className="text-muted-foreground mb-4">
                  We hope to make this transition easy and understandable for all of our customers. If you have any questions please do not hesitate to contact us.
                </p>
                <Link 
                  to="/contact" 
                  className="inline-flex items-center gap-2 text-primary hover:underline font-medium"
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomsDuty;
